var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.count > 0)?_c('div',{staticClass:"play-count-component"},[_c('div',{staticClass:"block"},[_c('ym-icon',{attrs:{"name":"round-play"}}),_c('span',[_vm._v(_vm._s(_vm.count))])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }